import { render } from "./QuatationAndProdInfo.vue?vue&type=template&id=23e52d04&scoped=true&lang=html"
import script from "./QuatationAndProdInfo.vue?vue&type=script&lang=js"
export * from "./QuatationAndProdInfo.vue?vue&type=script&lang=js"

import "./QuatationAndProdInfo.vue?vue&type=style&index=0&id=23e52d04&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e52d04"]])

export default __exports__